<!--
 * @Author: xuhuining
 * @Date: 2022-03-21 16:44:06
 * @LastEditors: xuhuining
 * @LastEditTime: 2022-04-21 19:59:40
 * @Description: 编辑推荐
-->
<template>
  <div class="edit_recommend" v-if="editRecommendList.length > 0">
    <div class="title" v-if="!isExpertsView">编辑推荐</div>
    <div class="content">
      <div v-for="item in editRecommendList" :key="item.id" class="list">
        <div
          class="item1 item"
          v-if="editRecommendList.length == 1"
          @click="toEditRecommend(item)"
        >
          <img :src="item.coverUrl" alt />
          <div class="text">{{ item.name }}</div>
        </div>
        <div
          class="item2 item"
          v-if="editRecommendList.length == 2"
          @click="toEditRecommend(item)"
        >
          <img :src="item.coverUrl" alt />
          <div class="text">{{ item.name }}</div>
        </div>
    </div>
      <div v-if="editRecommendList.length > 2" class="swiper">
        <!-- <mySwiper
          :swipeid="'exclusive_edit_swiper'"
          :loop="false"
          :slidesNum="2.48"
          :spaceBetweenNum="9"
        >
          <div
            class="swiper-slide"
            v-for="item in editRecommendList"
            :key="item.id"
            slot="swiper-con"
            @click="toEditRecommend(item)"
          >
            <img :src="item.img" alt />
            <div class="text">{{ item.title }}</div>
          </div>
        </mySwiper> -->
        <div
            class="swiper-slide"
            v-for="item in editRecommendList"
            :key="item.id"
            @click="toEditRecommend(item)"
          >
            <img :src="item.coverUrl" alt />
            <div class="text">{{ item.name }}</div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
// import mySwiper from "@/components/common/mySwiper/mySwiper.vue";
export default {
  name: "editRecommend",
  props: {
    editRecommendList: {
      type: Array,
      default: () => []
    },
    isExpertsView:{
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {};
  },
  components: {},

  computed: {},

  created() {},

  mounted() {},

  methods: {
    toEditRecommend(item) {
      this.$emit('toDetails', item)
    }
  }
};
</script>
<style lang="less" scoped>
.edit_recommend {
  margin: 12px auto 0;
  width: 343px;
  height: 159px;
  padding: 12px 12px 0;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 8px;
  .title {
    font-size: 15px;
    font-weight: bold;
    color: #333333;
    height: 21px;
    line-height: 21px;
  }
  .content {
    height: 100%;
    padding-top: 8px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    width: 331px;
    .list {
      .item {
        width: 319px;
        img {
          width: 100%;
          height: 78px;
          display: block;
          border-radius: 8px;
        }
        .text {
          padding-top: 8px;
          font-size: 13px;
          font-weight: bold;
          text-align: center;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          margin: auto;
          height: 20px;
          line-height: 20px;
        }
      }
      .item1 {
        .text {
          width: 303px;
        }
      }
      .item2 {
        width: 155px;
        .text {
          width: 139px;
        }
      }
    }
  
    .list:first-child {
      .item2 {
        padding-right: 9px;
      }
    }
    .swiper {
      height: 100%;
      overflow-x: scroll;
      display: flex;
      .swiper-slide:last-child {
        padding-right: 12px;
      }
      .swiper-slide {
        width: 128px;
        padding-right: 9px;
        img {
          width: 128px;
          height: 78px;
          display: block;
          border-radius: 8px;
        }
        .text {
          width: 120px;
          padding: 8px 4px 12px;
          font-size: 13px;
          font-weight: bold;
          text-align: center;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
}
</style>